import countries from 'i18n-iso-countries';
import enLocale from 'i18n-iso-countries/langs/en.json';

export const getCountryOptions = ({ filterByCode = '' } = {}) => {
  countries.registerLocale(enLocale);
  const countryNameList = countries.getNames('en', { select: 'official' });
  return Array.from(Object.entries(countryNameList))
    .map(([code, label]) => ({ code, label, toString: () => label }))
    .filter(({ code }) => code !== filterByCode);
};
